const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`, `0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`, 1, 61), new Map([[`labelledby_id`, `more-topics`]]), true, false, 1));
            }

            getTemplateName() {
                return `0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`, ``);
            }
        }],
        [61, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/overview/overview.twig`, `0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`, 1);

                this.blocks = new Map([
                    ['header', [this, 'block_header']],
                    ['actions', [this, 'block_actions']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/overview/overview.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_header(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -1], [`weight`, `light`], [`content`, `More Topics`], [`id`, `more-topics`]]), false, false, 5));
                this.echo(`  `);
            }

            block_actions(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(`    <label>
      <span class="u-hidden-visually">Search</span>
      `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, undefined, true, false, 19));
                this.echo(`    </label>
  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`, `0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`, 23, 60), new Map([[`tag_name`, `ul`], [`class`, `o-list--2-column@m o-list--3-column@l`]]), true, false, 23));
                this.echo(`  `);
            }

            getTemplateName() {
                return `0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`, ``);
            }
        }],
        [60, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/list/list.twig`, `0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`, 23);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/list/list.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`topics`) ? context.get(`topics`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`topic`] = __value__;
                    this.echo(`          `);
                    this.echo(`          <li class="u-pad-block-end-0">
            `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/dot-leader/dot-leader.twig`, new Map([[`label`, this.traceableMethod(this.getAttribute, 35, this.source)(this.env, context.get(`topic`), `title`, new Map([]), `any`, false, false, false)], [`count`, this.traceableMethod(this.getAttribute, 36, this.source)(this.env, context.get(`topic`), `count`, new Map([]), `any`, false, false, false)], [`href`, `https://cloudfour.com/thinks/`]]), false, false, 34));
                    this.echo(`          </li>
        `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('topic');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`      `);
            }

            getTemplateName() {
                return `0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017');

let template = env.loadTemplate('0a5185b902b84579fd24bf416715db7a257cc761ccf4a9c94ff14b1663d74017');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/overview/demo/advanced.twig", args: context }
     );
     return rendered;;
};